import { returnAllTradeDetailsFromGenericParams } from "@/lib/agGridColDefs/colDefGlobalHelpers";
import { updateTradeDataAcrossTablesAtBlockLevel } from "@/store/tradeDataStoreACTIONS";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { toast } from "react-toastify";
import {
  isFinalValidInputQuoteSize,
  isValidInputQuoteSize,
  returnQuoteSizeWithMConvertedToThousands,
} from "../../../../../lib/businessRules/quoteSizeRules";
import { useTheme } from "next-themes";

// ONLY USED FOR RP

const DynamicCellEditorQuoteSize = forwardRef((params: any, ref) => {
  const { theme } = useTheme();
  const { isOutright, isFuture, fullTradeData } =
    returnAllTradeDetailsFromGenericParams(params);

  const inputRef = useRef<HTMLInputElement>(null);

  const notionalLeg1 = isOutright
    ? params.data.legs?.[0]?.notionalLeg1
    : params.data.notionalLeg1;

  const tableValue = isOutright
    ? params.data.legs?.[0]?.quotedSize
    : params.value.toString();

  const [value, setValue] = useState(tableValue || "");

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  const handleInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    const input = event.target.value;

    if (!isValidInputQuoteSize(input)) {
      return; // return early and don't set the value if the input does not match rules.
    }
    // Update the value once validation has passed
    setValue(input);
  };

  const validateAndSave = () => {
    function processSavedQuoteSize() {
      // Check final input matches an approprate pattern.
      if (value > notionalLeg1) {
        toast(
          "Unable to set quote size larger than size. Quoted size set back to default.",
        );
        return notionalLeg1;
      }
      if (value < 1) {
        toast(
          "Unable to set quote size below 1. Quoted size set back to default.",
        );
        return notionalLeg1;
      }
      if (!isFinalValidInputQuoteSize(value)) {
        toast("Invalid format. Quoted size set back to default.");
        return notionalLeg1; // return early if invalid format.
      }

      // remove the m from the number and replace it with 000 each m.
      let numercialValueConverted =
        typeof value === "string"
          ? returnQuoteSizeWithMConvertedToThousands(value)
          : value;

      if (numercialValueConverted > notionalLeg1) {
        toast(
          "Unable to set quote size larger than size. Quoted size set back to default.",
        );
        return notionalLeg1;
      }
      if (isFuture) {
        numercialValueConverted = Math.round(numercialValueConverted);
      }

      return numercialValueConverted;
    }
    const savedValue = processSavedQuoteSize();

    const tradeESID = fullTradeData.esid;

    const newParams = { ...params };
    newParams.data.quotedSize = value;

    // Set the new value onto the leg of the tarde if it is an outright.
    if (isOutright && newParams.data.legs?.length > 0) {
      newParams.data.legs[0].quotedSize = savedValue;
    }

    updateTradeDataAcrossTablesAtBlockLevel(newParams, tradeESID);
    return savedValue;
  };
  useImperativeHandle(ref, () => ({
    getValue: () => validateAndSave(), // Preserve only fully valid values
  }));
  return (
    <input
      //   id="quoteInputEditor"
      ref={inputRef}
      type="string"
      value={value}
      onChange={handleInput} // Blocks unwanted characters immediately
      // className={`ag-input ag-roundedInputStyle flex w-full justify-center text-center`}

      className={`${
        theme === "light" ? "inputCellLight" : "inputCellDark"
      } ag-input ag-roundedInputStyle w-full justify-center !border-none text-center`}
      // className={`ag-input ag-roundedInputStyle flex w-full justify-center text-center`}
    />
  );
});

export default DynamicCellEditorQuoteSize;
